import { Record } from 'immutable';
export default class AssociationSpec extends Record({
  associationCategory: null,
  associationTypeId: null
}, 'AssociationSpec') {
  getAssociationCategory() {
    return this.associationCategory;
  }
  getAssociationTypeId() {
    return this.associationTypeId;
  }
  getFullAssociationTypeId() {
    return this.getAssociationTypeId() ? `${this.getAssociationTypeId()}--${this.getAssociationCategory()}` : undefined;
  }
}